import * as XLSX from "xlsx";
import React, { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import WriteInputArea from "@/pages/comp/plan/word/word_inside/common/write/area/write_input";

function TextBookAddWordArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    g_par_id: "",
    g_par_seq: "",
    word_type: "",
    ...props
  };

  let page_data = {
    word_type_text: myProps.word_type == "word" ? "단어" : "문장",
  };
  let user = useSelector((state: any) => state.user);
  let example_excel_img_src = process.env.REACT_APP_API_URL + "/img/comp/coolen/word/word_excel_up_ex.png";
  const [inside_info, set_inside_info] = useState<any>({
    a_seq: "",
    a_mcomp_seq: user.comp_seq,
    a_word_type: myProps.word_type,
    a_title: "",
    a_sort1: "",
    a_sort2: "",
    a_sort3: "",
    a_stu_grade: "",
    a_book_title: "",
    a_book_section: "",
    a_book_unit: "",
    a_year: "",
    a_round_num: "",
    a_writer: user.user_name,
    a_writer_seq: user.user_seq,
  });

  useEffect(() => {
    if (!strFunc.is_empty(myProps.g_par_seq)) {
      get_inside_info_by_ajax();
    }
  }, [user.comp_seq]);

  const get_inside_info_by_ajax = () => {
    let form_json_data: any = {
      s_mcomp_seq: user.comp_seq,
      s_seq: myProps.g_par_seq,
      is_paging: "",
    };
    if (strFunc.is_empty(form_json_data.s_mcomp_seq)) {
      return false;
    }
    if (strFunc.is_empty(form_json_data.s_seq)) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_inside_info(response.data["data"]["info_arr"][0]);
          } else {
            alert("선택하신 분류 정보가 존재하지 않습니다.");
            myProps.closePopup();
          }
        } else {
          alert("조회에 실패하였습니다." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  // 엑셀 데이터 상태
  const [excelData, setExcelData] = React.useState<{
    word_type: any; word: string, mean: string
  }[]>([]);

  // 텍스트 입력 상태
  const [textInput, setTextInput] = React.useState<string>("");

  // 중복 허용 옵션
  const [allowDuplicates, setAllowDuplicates] = React.useState<boolean>(false);

  // 엑셀 업로드 핸들러 (input, 드래그&드롭 공용)
  const handleExcelFile = (file: File) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = evt.target?.result;
      if (!data) return;
      const workbook = XLSX.read(data, { type: 'binary' });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
      let words: any = [];

      for (let row_i = 0; row_i < rows.length; row_i++) {
        let row: any = rows[row_i];
        let tmp_row_word_type = row[2] || myProps.word_type;
        if (tmp_row_word_type != "word" && tmp_row_word_type != "stc") {
          tmp_row_word_type = "word";
        }
        let word_row = {
          word: row[0] || '',
          mean: row[1] || '',
          word_type: tmp_row_word_type,
        };
        if (strFunc.is_empty(word_row.word_type)) {
          word_row.word_type = myProps.word_type;
        }
        words.push(word_row);
      }

      words = filter_word_arr({ word_arr: words });
      setExcelData(words);
      setTextInput(""); // 텍스트 입력 초기화
    };
    reader.readAsBinaryString(file);
  };

  const filter_word_arr = (inData: any) => {
    let opt_obj = {
      word_arr: [],
      ...inData
    };

    let word_arr = opt_obj.word_arr;

    for (let w_i = 0; w_i < word_arr.length; w_i++) {
      if (word_arr[w_i][0]) {
        word_arr[w_i][0] = strFunc.str_replace("'", "’", word_arr[w_i][0]);
        word_arr[w_i][0] = strFunc.str_replace("  ", " ", word_arr[w_i][0]);
      }
    }

    return word_arr;
  };

  // input file change
  const handleExcelUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) handleExcelFile(file);
  };

  // 드래그&드롭 상태
  const [dragActive, setDragActive] = React.useState(false);
  const dropRef = React.useRef<HTMLDivElement>(null);

  // 드래그 이벤트 핸들러
  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleExcelFile(e.dataTransfer.files[0]);
    }
  };
  // 클릭시 input file 열기
  const handleClick = () => {
    document.getElementById('excel-upload')?.click();
  };

  // 문장 여부 체크 함수 (한국어, 영어 모두 지원)
  const isSentence = (text: string) => {
    const trimmed = text.trim();

    // 빈 문자열이면 false
    if (!trimmed) return false;

    // 문장 부호로 끝나는지 체크
    const sentenceEnders = /[.!?。！？]/;
    if (sentenceEnders.test(trimmed)) return true;

    // 공백이 포함된 여러 단어로 이루어진 경우 (최소 4개 단어 이상)
    const words = trimmed.split(/\s+/).filter(word => word.length > 0);
    if (words.length >= 4) return true;

    return false;
  };

  // 텍스트 파싱 함수
  const parseTextData = (text: string) => {
    const lines = text.trim().split('\n');
    let words = lines.map(line => {
      // 탭, 스페이스로 구분된 데이터 파싱
      let parts: any = [];
      if (line.indexOf("\t") != -1) {
        parts = line.split(/[\t]\s*/).filter(part => part.trim());
      } else if (line.indexOf("  ") != -1) {
        parts = parts = line.split(/[\s]{2,}/).filter(part => part.trim());
      }
      let tmp_row_word_type = parts[2] || myProps.word_type;
      if (tmp_row_word_type != "word" && tmp_row_word_type != "stc") {
        tmp_row_word_type = "word";
      }
      return {
        word: parts[0] || '',
        mean: parts[1] || '',
        word_type: tmp_row_word_type,
      };
    }).filter(w => w.word);
    words = filter_word_arr({ word_arr: words });
    return words;
  };

  // 텍스트 입력 변화 처리
  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setTextInput(value);

    if (value.trim()) {
      const parsedData = parseTextData(value);
      setExcelData(parsedData);
    } else {
      setExcelData([]);
    }
  };
  //단어그룹먼저 등록
  const save_word_inside_by_ajax = () => {
    if (excelData.length === 0) {
      alert('등록할 ' + page_data.word_type_text + '가 없습니다.');
      return;
    }

    if (strFunc.is_empty(inside_info.a_title)) {
      alert("제목을 입력하세요.");
      return;
    }

    let form_json_data: any = {
      data_arr: [inside_info]
    };
    if (strFunc.is_empty(inside_info.a_seq)) {
      form_json_data["is_default_val"] = "1";
      form_json_data["data_arr"][0].a_mcomp_seq = user.comp_seq;
    }
    if (strFunc.is_empty(form_json_data["data_arr"][0].a_mcomp_seq)) {
      alert("로그인 정보가 올바르지 않습니다.");
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"].length > 0) {
            set_inside_info(response.data["data"][0]);
            handleWordRegistration({
              g_par_seq: response.data["data"][0].a_seq,
            });
          } else {
            alert("저장된 데이터가 없습니다.");
            myProps.closePopup();
          }
        } else {
          alert("저장 중 오류." + response.data["msg"]);
        }
      });
  };

  // 단어 정제 및 등록 처리
  const handleWordRegistration = (inData: any) => {
    let opt_obj = {
      g_par_seq: inside_info.a_seq,
      ...inData
    };
    if (excelData.length === 0) {
      alert('등록할 ' + page_data.word_type_text + '가 없습니다.');
      return;
    }

    // 단어 데이터 정제 및 타입 구분
    const cleanedWords = excelData.map(item => {
      const word = item.word?.trim() || '';
      const mean = item.mean?.trim() || '';
      let word_type = item.word_type?.trim() || myProps.word_type;
      if(word_type!="word"&&word_type!="stc"){
        word_type="word";
      }

      return {
        word,
        mean,
        word_type: word_type,
      };
    }).filter(item => item.word && item.mean); // 빈 값 제거

    if (cleanedWords.length === 0) {
      alert('유효한 데이터가 없습니다.' + page_data.word_type_text + '와 뜻이 모두 입력된 데이터만 등록 가능합니다.');
      return;
    }

    // 중복 처리
    let finalWords = cleanedWords;
    let duplicateCount = 0;

    if (!allowDuplicates) {
      // 중복 단어 제거 (대소문자 구분 없음)
      const uniqueWords = cleanedWords.filter((word, index, self) =>
        index === self.findIndex(w => w.word.toLowerCase() === word.word.toLowerCase())
      );

      duplicateCount = cleanedWords.length - uniqueWords.length;
      finalWords = uniqueWords;

      if (duplicateCount > 0) {
        console.log(`중복 ${page_data.word_type_text} ${duplicateCount}개가 제거되었습니다.`);
      }
    }

    // 등록할 데이터 구성
    const registrationData = {
      g_par_id: myProps.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      word_arr: finalWords,
    };

    if (!confirm(page_data.word_type_text + "를 등록 하시겠습니까?")) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/add_words',
      registrationData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(page_data.word_type_text + " 등록이 완료되었습니다.");
          myProps.refreshData({});
          myProps.closePopup();
        } else {
          alert(page_data.word_type_text + " 등록에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 32,
          alignItems: 'center',
          marginBottom: 18,
          flexWrap: 'wrap',
        }}
      >
        {/* 엑셀 예시 */}
        <div style={{
          background: '#f8fafc',
          border: '1px solid #e0e7ef',
          borderRadius: 12,
          padding: '20px 24px 18px 24px',
          boxShadow: '0 2px 8px 0 rgba(0,0,0,0.03)',
          maxWidth: 420,
          minWidth: 260,
          flex: '1 1 320px',
        }}>
          <div style={{ fontWeight: 700, fontSize: 18, color: '#1976d2', marginBottom: 10, letterSpacing: '-0.5px' }}>
            <span style={{ marginRight: 8, fontSize: 20 }}>📄</span>엑셀 파일 예시
          </div>
          <ul style={{
            margin: 0,
            padding: '0 0 0 20px',
            fontSize: 15,
            color: '#333',
            lineHeight: 1.8,
            listStyle: 'disc',
            marginBottom: 12
          }}>
            <li>첫 번째 열: <b>단어/문장</b> <span style={{ color: '#ff6b35', fontWeight: 500 }}>(필수)</span></li>
            <li>두 번째 열: <b>뜻</b> <span style={{ color: '#ff6b35', fontWeight: 500 }}>(필수)</span></li>
            <li>세 번째 열: <b>유형(word,stc)</b> <span style={{ color: '#ff6b35', fontWeight: 500 }}></span></li>
          </ul>
          <img
            src={example_excel_img_src}
            alt="엑셀 예시 이미지"
            style={{
              display: 'block',
              margin: '10px auto 0 auto',
              border: '1.5px solid #e0e7ef',
              borderRadius: 8,
              maxWidth: '100%',
              boxShadow: '0 1px 6px 0 rgba(0,0,0,0.06)',
              height: "120px"
            }}
          />
        </div>
        {/* 업로드 인풋 */}
        <div
          ref={dropRef}
          onClick={handleClick}
          onDragEnter={handleDrag}
          onDragOver={handleDrag}
          onDragLeave={handleDrag}
          onDrop={handleDrop}
          style={{
            border: dragActive ? '2px solid #1976d2' : '2px dashed #aaa',
            borderRadius: 12,
            minHeight: 150,
            minWidth: 220,
            flex: '1 1 260px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: dragActive ? '#e3f2fd' : '#fafafa',
            color: '#555',
            fontSize: 18,
            cursor: 'pointer',
            margin: 0,
            transition: 'all 0.2s',
            boxSizing: 'border-box',
          }}
        >
          {dragActive ? '엑셀 파일을 여기에 놓으세요' : (
            <span>엑셀 파일을 이 영역에<br />드래그하거나 클릭해서 업로드</span>
          )}
          <input
            id="excel-upload"
            type="file"
            accept=".xlsx,.xls"
            onChange={handleExcelUpload}
            style={{ display: 'none' }}
          />
        </div>
      </div>
      <div style={{ margin: '20px 0' }}>
        <div style={{ marginBottom: 10, fontSize: 16, fontWeight: 600, color: '#333' }}>
          직접 입력(한 줄에 하나씩, 탭 또는 스페이스 2칸 으로 구분)
        </div>
        <textarea
          value={textInput}
          onChange={handleTextChange}
          placeholder="예시:&#10;apple&#9;사과"
          style={{
            width: '100%',
            minHeight: 50,
            padding: 12,
            border: '1px solid #ddd',
            borderRadius: 8,
            fontSize: 14,
            fontFamily: 'monospace',
            resize: 'vertical',
            outline: 'none',
          }}
        />
        <div style={{ fontSize: 12, color: '#666', marginTop: 5 }}>
          형식: 단어(문장)[탭 또는 쉼표]뜻 (한 줄에 하나씩)
        </div>
      </div>

      <div style={{ marginTop: 15, paddingLeft: 4 }}>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: 14,
          color: '#555',
          cursor: 'pointer',
          userSelect: 'none'
        }}>
          <input
            type="checkbox"
            checked={allowDuplicates}
            onChange={(e) => setAllowDuplicates(e.target.checked)}
            style={{
              marginRight: 8,
              width: 16,
              height: 16,
              cursor: 'pointer'
            }}
          />
          중복 단어(문장) 허용 (체크 해제 시 중복 단어(문장)를 자동으로 제거합니다)
        </label>
      </div>

      <WriteInputArea
        inside_info={inside_info}
        set_inside_info={set_inside_info}
      ></WriteInputArea>

      <div style={{ marginTop: 20 }}>
        {excelData.length > 0 && (
          <div>
            <h3 style={{ marginBottom: 15, color: '#333', fontSize: 18 }}>
              업로드된 데이터 ({excelData.length}개)
              <span style={{
                marginLeft: 10,
                fontSize: 14,
                color: '#666',
                fontWeight: 400
              }}>
                단어: {excelData.filter(item => !isSentence(item.word)).length}개,
                문장: {excelData.filter(item => isSentence(item.word)).length}개
              </span>
            </h3>
            <div style={{
              maxHeight: 400,
              overflowY: 'auto',
              border: '1px solid #ddd',
              borderRadius: 8,
              background: '#fff'
            }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>단어/문장</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>뜻</th>
                    <th style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 600, width: 80 }}>타입</th>
                  </tr>
                </thead>
                <tbody>
                  {excelData.map((item, index) => {
                    const isWordSentence = item.word_type === 'stc' ? true : false;
                    return (
                      <tr key={index} style={{ borderBottom: index < excelData.length - 1 ? '1px solid #eee' : 'none' }}>
                        <td style={{ padding: '12px 16px', color: '#333' }}>{item.word || '-'}</td>
                        <td style={{ padding: '12px 16px', color: '#666' }}>{item.mean || '-'}</td>
                        <td style={{
                          padding: '12px 16px',
                          textAlign: 'center',
                          fontSize: 12,
                          color: isWordSentence ? '#ff6b35' : '#1976d2',
                          fontWeight: 500
                        }}>
                          {isWordSentence ? '문장' : '단어'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <div style={{
        marginTop: 30,
        display: 'flex',
        justifyContent: 'center',
        gap: 15,
        paddingTop: 20,
        borderTop: '1px solid #eee'
      }}>
        <button
          onClick={() => { save_word_inside_by_ajax(); }}
          disabled={excelData.length === 0}
          style={{
            padding: '12px 24px',
            backgroundColor: excelData.length === 0 ? '#ccc' : '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 600,
            cursor: excelData.length === 0 ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.2s'
          }}
        >
          {page_data.word_type_text} 등록 ({excelData.length}개)
        </button>
        <button
          onClick={myProps.closePopup}
          style={{
            padding: '12px 24px',
            backgroundColor: '#666',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
        >
          닫기
        </button>
      </div>
    </div>
  );
};
export default TextBookAddWordArea;